import React, { Component } from 'react';
import { Modal, message } from 'antd';
import axios from "axios";

class DeleteMaterialModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmLoading: false,
            extraMaterials: []
        };
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.deleteMaterial = this.deleteMaterial.bind(this);
    }
    handleOk = () => {
        this.deleteMaterial();
    };
    handleCancel = () => {
        this.props.handleOpenModal(false);
    };
    deleteMaterial = async () => {
        this.setState({ confirmLoading: true });
        let route = this.props.materialToDelete.material_type ? `https://backoffice.nadu.xyz/api/materials/${this.props.materialToDelete.id}` : `https://backoffice.nadu.xyz/api/material-type/delete/${this.props.materialToDelete.uuid}`;
        try {
            const res = await axios.delete(route);
            if (res.data) {
                message.success('Se ha eliminado el material');
                this.props.reloadCall()
            } else {
                message.error('Error al eliminar el material');
            }
        } catch (error) {
            message.error('Error al eliminar el material');
            console.log(error)
        }
        this.setState({ confirmLoading: false });
        this.props.handleOpenModal(false);
    }
    render() {
        const { materialToDelete } = this.props;
        const { confirmLoading } = this.state;
        return (
            <Modal
                title={"¿Estás seguro de eliminar " + (materialToDelete.material_type ? materialToDelete.material_type.name : materialToDelete.name) + "?"}
                open={true}
                onOk={this.handleOk}
                centered={true}
                confirmLoading={confirmLoading}
                onCancel={this.handleCancel}
            >
            </Modal>
        );
    }
}

export default DeleteMaterialModal;



// WEBPACK FOOTER //
// ./src/views/HomeVisits/DeleteMaterialModal.jsx